import { Injectable, computed, signal } from '@angular/core';

import { SHARED_UI_COMPONENTS, SharedUiComponentDoc } from './components-screen.types';

@Injectable({ providedIn: 'root' })
export class ComponentsScreenService {
  readonly components = signal<SharedUiComponentDoc[]>(SHARED_UI_COMPONENTS);

  readonly highUsageCount = computed(() => this.components().filter((item) => item.usageStatus === 'High').length);
  readonly mediumUsageCount = computed(() => this.components().filter((item) => item.usageStatus === 'Medium').length);
  readonly categoryCount = computed(() => new Set(this.components().map((item) => item.category)).size);
}
